export default "__VITE_ASSET__BbuIWxWs__"